/** True on iPhone/iPad Safari and similar touch WebKit environments. */
export function isIosTouchDevice(): boolean {
  if (typeof window === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return (
    /iPad|iPhone|iPod/.test(ua)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
}

/**
 * Embedded in-app browsers (Outlook, etc.) on mobile often break blob PDF iframes
 * and can report odd layout viewports. Prefer scrollable PDF rendering there.
 */
export function shouldUseScrollablePdfPreview(): boolean {
  if (typeof window === 'undefined') return false;
  if (isIosTouchDevice()) return true;
  const ua = navigator.userAgent || '';
  const isEmbedded = /Outlook|MSOffice|GSA\/|FBAN|FBAV|Instagram|Line\//i.test(ua);
  return isEmbedded && window.matchMedia('(pointer: coarse)').matches;
}
